import { combineEpics } from 'redux-observable';
import { loadProfilingDataSourcesEpicReducer } from '../ducks/DataSourceProfiling.ducks';
export default combineEpics(loadProfilingDataSourcesEpicReducer.epic);

//# sourceMappingURL=DataSourceProfilingEpic.js.map
